import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { BpOption } from "@models/ui-components/bp-option";

@Component({
	selector: "bp-toggle-group",
	templateUrl: "./bp-toggle-group.component.html",
	styleUrls: ["./bp-toggle-group.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpToggleGroupComponent<T, U> {
	@Input() public options: BpOption<T, U>[] = [];
	@Input() public selected?: BpOption<T, U> = null;
	@Input() public isSmall: boolean = false; // toggles smaller version for e.g. timeframe filter
	@Input() public margin: boolean = false;

	@Output() public onValueChange: EventEmitter<BpOption<T, U>> = new EventEmitter<BpOption<T, U>>();

	public onOptionClick(option: BpOption<T, U>): void {
		this.selected = option;
		this.onValueChange.emit(option);
	}
}
